import {InboxOutlined} from '@ant-design/icons';
import type {UploadProps} from 'antd';
import {Alert, message, Space, Typography, Upload} from 'antd';
import React, {useState} from 'react';
import {RcFile} from "antd/es/upload";
import Api from "../Api";
import {useUpload} from "../../context/Upload";
import {AxiosError} from "axios";

const {Dragger} = Upload;
const {Text, Title} = Typography;

const beforeUpload = (file: RcFile) => {
    const mimeTypes = ["text/csv", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]
    const isCsv =  mimeTypes.includes(file.type) ;
    if (!isCsv) {
        message.error('You can only upload CSV file!');
    }
    const isMaxSize = file.size / 1024 / 1024 < 512;
    if (!isMaxSize) {
        message.error('CSV file must smaller than 512MB!');
    }
    return isCsv && isMaxSize;
};


const UploadStep = () => {
    const {options, status, setStatus} = useUpload();
    const [errors, setErrors] = useState<Array<{ Reason: string }>>([])

    const uploadFile = async (opts: any) => {
        const {onSuccess, onError, file, onProgress} = opts;
        const formData = new FormData();
        formData.set('filename', file.name)
        formData.set('folder', options.selectedDataType!)
        formData.set('groups', options.selectedDestination!)
        formData.set("file_content", file)
        try {
            setErrors([])
            await Api.management.upload(
                formData,
                (event: any) => {
                    const percent = Math.floor((event.loaded / event.total) * 100);
                    console.log(percent)
                    onProgress({percent: (event.loaded / event.total) * 100});
                }
            );
            setStatus({...status, done: true})
            onSuccess("OK")
        } catch (err) {
            if (err instanceof AxiosError && Array.isArray(err.response!.data)) {
                setErrors(err.response!.data);
            }
            setStatus({...status, done: false})
            onError("Error")
        }
    }

    const props: UploadProps = {
        beforeUpload: beforeUpload,
        name: 'file',
        multiple: false,
        headers: {"content-type": "multipart/form-data"},
        customRequest: uploadFile,
        onChange(info) {
            const {status} = info.file;
            console.log('status', status)
            if (status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };
    return (
        <Space style={{width: "100%"}} direction="vertical">
            <Dragger {...props}>
                <p className="ant-upload-drag-icon">
                    <InboxOutlined/>
                </p>
                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                <p className="ant-upload-hint">
                    Only supports comma separated values (csv) files
                </p>
            </Dragger>
            {errors.map((error, key) => (
                <Alert
                    key={key}
                    message={error.Reason}
                    type="error"
                    showIcon
                    closable
                />
            ))}
        </Space>
    )
}

export default UploadStep;
